import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEqual } from "lodash";
import React, { memo } from "react";
import { KEY_ENTER, KEY_SPACE } from "@config/constants";
var LiveButton = function(param) {
    var disabled = param.disabled, getButtonsData = param.getButtonsData, onClick = param.onClick;
    var onKeyDownHandler = function(e) {
        e.stopPropagation();
        var key = e.which;
        if (key === KEY_SPACE || key === KEY_ENTER) {
            onClick(true);
        }
    };
    var buttonsData = getButtonsData();
    var buttonState = disabled && /*#__PURE__*/ _jsx("span", {
        className: "live",
        children: "•"
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "live-button player-button".concat(disabled ? " disabled" : ""),
        onClick: onClick,
        onKeyDown: onKeyDownHandler,
        tabIndex: "0",
        children: /*#__PURE__*/ _jsxs("span", {
            "data-for": "player-tooltip",
            "data-tip": buttonsData.live.dataTip,
            children: [
                buttonState,
                " LIVE"
            ]
        })
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(LiveButton, areEqual);
